import debounce from 'lodash/debounce'
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'

import { useAxios } from '../../hooks/use_axios'
import { getCurrentHandle } from '../../reduxes/slices/current/selectors'
import { updateMeeting } from '../../reduxes/slices/meetings/actions'

type Props = {
  meeting: any
} & React.HTMLAttributes<HTMLDivElement>

export const ResponseOptions = ({ meeting, ...props }: Props) => {
  const dispatch = useDispatch()
  const axios = useAxios()
  const { id, topic_id: topicId } = meeting
  const responses = JSON.parse(meeting.responses)
  const currentHandle = useSelector(getCurrentHandle)
  const ownResponse = responses[currentHandle]
  const updateResponse = useMemo(
    () =>
      debounce(
        (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          dispatch(
            axios(
              updateMeeting(topicId, id, {
                // eslint-disable-next-line
                // @ts-ignore
                response: event.target.value,
              }),
              // eslint-disable-next-line
              // @ts-ignore
            ),
          ).catch(() => null)
        },
        500,
        { leading: true },
      ),
    [axios, dispatch, id, topicId],
  )

  return (
    <Stack
      direction={'row'}
      gap={2}
      {...props}
      css={{ '>*': { flex: '1 1 33.3%' } }}
    >
      <Button
        value={'accepted'}
        onClick={updateResponse}
        toggled={ownResponse === 'accepted'}
      >
        {ownResponse === 'accepted' ? 'Accepted' : 'Accept'}
      </Button>
      <Button
        value={'maybe'}
        onClick={updateResponse}
        toggled={ownResponse === 'maybe'}
      >
        Maybe
      </Button>
      <Button
        value={'rejected'}
        onClick={updateResponse}
        toggled={ownResponse === 'rejected'}
      >
        {ownResponse === 'rejected' ? 'Declined' : 'Decline'}
      </Button>
    </Stack>
  )
}
